import { render, staticRenderFns } from "./cascader-items.vue?vue&type=template&id=62b8cfa4&scoped=true&"
import script from "./cascader-items.vue?vue&type=script&lang=js&"
export * from "./cascader-items.vue?vue&type=script&lang=js&"
import style0 from "./cascader-items.vue?vue&type=style&index=0&id=62b8cfa4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b8cfa4",
  null
  
)

export default component.exports